import Swiper, { Pagination, Lazy } from "swiper"

const swiperProductIntro = {
    swiperInstance: null,
    swiperElement: null,
    firstSlide: null,
    init: () => {

        let domEls = document.querySelectorAll('.js-swiper-container-product-intro');
        if (domEls) {
            const params = getSwiperParams();
            domEls.forEach(el => {
                swiperProductIntro.swiperInstance = new Swiper(el, params);   //NOSONAR
            })
        }
    }
};

const getSwiperParams = () => {
    return {
        modules: [ Pagination, Lazy ],
        watchOverflow: true,
        centeredSlides: true,
        speed: 500,
        spaceBetween: 0,
        slidesPerView: 1,
        resizeObserver: true,
        a11y: true,
        grabCursor: true,
        preloadImages: false,
        lazy: {
            loadPrevNext: true
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        // on: {
        //     init() {
        //         swiperProductIntro.swiperElement = this.$el[0];
        //         swiperProductIntro.firstSlide = swiperProductIntro.swiperElement.querySelectorAll('.swiper-slide-active')[0];
        //         swiperProductIntro.firstSlide.classList.remove('swiper-slide-active');
        //         setTimeout(function() {
        //             swiperProductIntro.firstSlide.classList.add('swiper-slide-active');
        //         }, 500);
        //     },
        // }
    };
}

export default swiperProductIntro;
